<template>
  <div class="my-3 pa-1">
    <!-- move to it's own component -->
    <v-btn
      width="90%"
      depressed
      small
      class="mb-1 mx-auto"
      to="/icd10/"
      color="blue lighten-5"
      >ICD10 Home</v-btn
    >
    <v-btn
      width="90%"
      depressed
      small
      class="mb-1 mx-auto"
      to="/icd10/diabetic-retinopathy-widget"
      color="#fde3e3 "
      ><v-icon small class="mr-1">mdi-sitemap</v-icon>Diabetes Widget</v-btn
    >
    <!-- <v-btn
      width="90%"
      depressed
      small
      class="mb-1 mx-auto"
      to="/billingCodes"
      color="#d0fbd4"
      ><v-icon small class="mr-1">mdi-sitemap</v-icon>EM &amp; CPT Codes</v-btn
    > -->
    <div
      v-for="(section, index) in buttons"
      :key="index"
      class="my-3 pa-1 allBtnsDiv"
    >
      <v-btn
        width="90%"
        depressed
        small
        v-for="(btn, index) in section"
        :key="index"
        class="my-1 mx-auto"
        active-class="activeButton"
        :to="{ path: '/icd10/' + btn.href, query: { title: btn.title } }"
        >{{ btn.title }}</v-btn
      >
    </div>
    <v-btn
      width="90%"
      depressed
      small
      class="mb-1 mx-auto"
      to="/icd10/chapters"
      color="blue lighten-5"
      >Browse All Codes</v-btn
    >

    <coding-see-also currentKey="icd10" class="mt-4"></coding-see-also>
  </div>
</template>

<script>
import CodingSeeAlso from "@/components/icdStuff/CodingSeeAlso.vue";
// import Name from "../dir/file";

export default {
  name: "icdMenuBtns",
  components: {
    CodingSeeAlso,
  },
  props: {},
  data: function () {
    return {
      buttons: [
        // { title: "All Eye Codes", href: "H00-H59" },
        [
          { title: "Refractive & Accom.", href: "H52" },
          { title: "Vision Problems", href: "H53,H54" },
          { title: "Headache/Migraine", href: "R51,G44,G43" },
          // { title: "Blindness", href: "H54" },
          // { title: "Binocular disorders", href: "H51" },
          { title: "Strabismus & EOMs", href: "H50,H51,H49,H55" },
          // { title: "Nystagmus", href: "H55" },
        ],
        [
          { title: "Eyelids", href: "H00-H03,H57.8" },
          { title: "Lacrimal", href: "H04" },

          { title: "Conjunctiva", href: "H10-H11" },
          { title: "Sclera/Episclera", href: "H15" },
          { title: "Cornea", href: "H16-H18,S05.0,T15.0" },
          { title: "Iris/Pupil", href: "H19-H22,H57.0" },
          // { title: "Pupil", href: "" },
          { title: "Lens (Cataract)", href: "H25-H28" },
        ],
        [
          { title: "Retina & Choroid", href: "H30-H36" },
          { title: "Diabetic Retinopathy", href: "diabetes" },

          { title: "Vitreous", href: "H43" },
          { title: "Optic Nerve", href: "H46-H47" },
          { title: "Nevi", href: "D31,C69" },
          { title: "Glaucoma", href: "H40-H42" },
        ],
        [
          { title: "Globe/Orbit", href: "H05,H44" },
          { title: "Post-operative", href: "H59" },
          // { title: "Other", href: "H57" },
        ],
      ],
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.allBtnsDiv >>> .activeButton {
  background-color: #d6f3ff;
}
</style>
